import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  to?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  onClick?: () => void; // Allow custom click handler
}

export function BackButton({ to = "/trips", className = "", size = "md", onClick }: BackButtonProps) {
  const navigate = useNavigate();

  const sizeClasses = {
    sm: "w-4 h-5",
    md: "w-5 h-6",
    lg: "w-6 h-7"
  };

  const buttonSizeClasses = {
    sm: "p-1.5",
    md: "p-2",
    lg: "p-2.5"
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`hover:bg-gray-100 active:bg-gray-200 rounded-full transition-colors duration-150 ${buttonSizeClasses[size]} ${className}`}
      aria-label="Go back"
    >
      <svg
        className={`${sizeClasses[size]} text-gray-600`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
  );
}
